import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../../store/http/http.service';

@Injectable({ providedIn: 'root' })
export class AiService {
  constructor(private http: HttpService) {}

  // postClaudeStructured(payload: any): Observable<any> {

  //   return this.http.post('/claude/structured', payload);
  // }

  requestScenes(model: 'openai' | 'claude', prompt: string): Observable<any> {
    if (model === 'openai') {
      return this.http.post(`ai/${model}/structured`, {
        prompt,
        extraParams: {
          tools: [
            {
              type: 'function',
              function: {
                name: 'generate_scene_descriptors',
                description:
                  'Generate structured scene descriptors for an animated video based on a text plot',
                parameters: {
                  type: 'object',
                  properties: {
                    scenes: {
                      type: 'array',
                      items: {
                        type: 'object',
                        properties: {
                          description: {
                            type: 'string',
                          },
                        },
                        required: ['description'],
                      },
                    },
                  },
                  required: ['scenes'],
                },
              },
            },
          ],
          tool_choice: {
            type: 'function',
            function: {
              name: 'generate_scene_descriptors',
            },
          },
        },
      });
    } else {
      return this.http.post(`ai/${model}/structured`, {
        prompt,
        extraParams: {
          tools: [
            {
              name: 'extract_scenes',
              description:
                'Extract a list of scene descriptions for an animated video',
              input_schema: {
                type: 'object',
                properties: {
                  scenes: {
                    type: 'array',
                    items: {
                      type: 'string',
                    },
                    description: 'Each item is a description of a scene',
                  },
                },
                required: ['scenes'],
              },
            },
          ],
          tool_choice: {
            type: 'tool',
            name: 'extract_scenes',
          },
        },
      });
    }
  }
  requestObjects(model: 'openai' | 'claude', prompt: string): Observable<any> {
    return this.http.post(`/ai/${model}/scenes`, { prompt });
  }

  requestActions(model: 'openai' | 'claude', prompt: string): Observable<any> {
    return this.http.post(`/ai/${model}/actions`, { prompt });
  }
}
